<template>
  <div id="app">
	<!-- 3.使用组件 -->
    <roheader></roheader>
   <!-- <testprops title="hellsksksksksks" color='red'></testprops>
		中间内容哦耶 -->
	<!-- 内容 -->
	<div class="ro-home-content-login">
		<div class="ro-home-content-box-login">
			<div style="width: 50%;float: left;text-align: left;margin-top: 100px;">
				<span style="font-weight:800;">科技查新及查收查引服务系统</br></span>
				科技查新及查收查引是图书馆依托丰富的馆藏和网络资源优势，</br>
				由专业查新人员根据用户提出的具体要求，</br>
				为用户提供查新及检索结果的一项服务。</br>
			</div>
			<div style="width: 450px;float: right;height:450px;background-color: white;border-radius: 5px;padding:40px;box-shadow:0px 0px 20px #8a8a8a;">
				<h6>查新中心登陆</h6>
				<div class="form-group" style="margin-top: 50px;">
					<i class="fal small el-icon-phone" style="top:15px;"></i>
					<input type="text" class="form-control style2" v-model="phone" placeholder="手机号码" style="border-radius: 10px;height:50px;margin-bottom: 15px;"/> 
				</div>
				<div class="form-group">
					<i class="fal small"></i>
					<input type="password" class="form-control style2" v-model="password" placeholder="密码" style="border-radius: 10px;height:50px;margin-bottom: 15px;"/> 
				</div>
				<!-- <el-checkbox>自动登陆</el-checkbox> -->
				<a class="col-xl-12 text-center" @click="check_login()">
					<button type="submit" class="vs-btn style2" style="border-radius: 10px;height:50px;margin-bottom: 15px;width: 100%;margin-left: 0;">登陆</button>
				</a>
				<div style="overflow: hidden;">
					<span style="float: left;font-size: 12px;">
						还没有账号？<a href="#/home/register" class="link-btn">立即注册</a>
					</span>
					<span style="float: right;font-size: 12px;">
						<a href="#/home/forget" class="link-btn">忘记密码</a>
					</span>
				</div>
			</div>
		</div>
	</div>
	<!-- 页脚 -->
    <rofooter ></rofooter>
  </div>
</template>
<script>
// 1.导入组件
import roheader from "./components/ro_header.vue";
import rofooter from "./components/ro_footer.vue";
import testprops from "./components/test_props.vue";
	import {
		fetchPost
	} from "@/utils/request"
export default {
  name: "App",
  components: {
    // 2.注册局部组件
    roheader,
    rofooter,
	testprops,
  },
  data() {
  	return {
		phone: '', 
		password: '', 
	}},
  methods: {
	  check_login(){
		  var data = {
			  'mobile':this.phone,
			  'password':this.password
		  }
		  fetchPost('/ro/tec_search/user/login/v1',data).then(response => {
				if(response.data.result=='fail'){
					this.$message.error(response.data.reason)
				}
				else{
					// debugger
					console.log('login-----------')
					console.log(response.data)
					window.localStorage.setItem('user_id',response.data.user_id)
					window.localStorage.setItem('phone', response.data.phone)
					window.localStorage.setItem('email', response.data.email)

					window.localStorage.setItem('session_id', response.data.session_id)
					window.localStorage.setItem('livechat_token', response.data.livechat_token || '')
					window.localStorage.setItem('message_qty', response.data.message_qty)
					window.location.href = '#/user/notice'
					console.log(response.data.notify_message)
					console.log(response.data.notify_title)
					window.localStorage.setItem('notify_message', response.data.notify_message)
					window.localStorage.setItem('notify_title', response.data.notify_title)
					
				}
		  })
	  },
  }

};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.ro-home-content-login{
	width:100%;
	background: #F0F0F0;
	height:800px;
	padding:150px 0;
	background-image:url(../assets/img/bg/bg-7.jpg);
	background-repeat: no-repeat;
	background-position: 50%;
	background-size: cover;
	overflow: auto;
}
.ro-home-content-box-login{
	width: 1000px;
	margin:auto;
	padding:40px 0;
}
.vs-btn.style3:before, .vs-btn.style2:before{
	position: unset; 
}
</style>
